export default "__VITE_ASSET__cntl8fSP__"